
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M13.005 1.5C14.107 1.5 15 2.393 15 3.495v7.01a1.995 1.995 0 01-1.995 1.995h-4.82l-3.324 2.542a.5.5 0 01-.216.095l-.08.008a.5.5 0 01-.498-.402l-.01-.09-.034-2.153H2.995A1.995 1.995 0 011 10.505v-7.01C1 2.393 1.893 1.5 2.995 1.5h10.01zm-3.73 6.075H5a.75.75 0 000 1.5h4.275a.75.75 0 000-1.5zM11 4.75H5a.75.75 0 000 1.5h6a.75.75 0 100-1.5z"}})])
          )
        }
      }
    